export const MAX_INT = 2147483647;
